// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkflowFinishedPanel_root__2Z5Ko","message":"WorkflowFinishedPanel_message__2fSz6"};